export enum VisitStatus {
  Early = "early",
  Late = "late",
  Valid = "valid",
}
